module.exports = "/_next/static/images/logo-company-5bdb1a29ac5875b1c76fca17fc182a0a.svg";